import * as React from 'react'
import { ModalConfig, ModalParams, ModalTypes } from '@components/modals/types'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { findModalSelector, setModalIsOpen, setShowModal } from '@store/slices/modal-slice'

export const useModal = (modalName: ModalTypes, modalParams?: ModalParams, config?: ModalConfig) => {
  const dispatch = useDispatch()
  const hasModal = !!useSelector((state: RootState) => findModalSelector(state, modalName))

  const hideModal = React.useCallback(() => dispatch(setModalIsOpen({ modal: modalName, isOpen: false })), [modalName])

  const toggleIsOpen = React.useCallback(
    (event?, optionalParams?: ModalParams, showModal?: boolean) => {
      if (hasModal && !showModal) {
        return hideModal()
      } else {
        return dispatch(
          setShowModal({ modal: modalName, params: { ...optionalParams, ...modalParams, config }, isOpen: true }),
        )
      }
    },
    [modalName, hasModal, modalParams],
  )

  return [toggleIsOpen, hideModal]
}
